export namespace ApiLocation
{

    export const BET = "api/json/aviator/v1/place-bet";
    export const REFRESH= "api/json/aviator/v1/get-game-info";
    export const CASHOUT= "api/json/crash/v1/cashout";
    export const CHAT= "api/json/chat/v1/send";

}